import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-mini-load',
  templateUrl: './mini-load.component.html',
  styleUrls: ['./mini-load.component.css'],
})
export class MiniLoadComponent implements OnInit {
  @Input() text: string;

  constructor() {}

  ngOnInit(): void {}
}
